import React, { useState } from "react";
import { imageUrl } from "./rewardsData";

// A badge's image, or a gift icon when the badge has none or its image does
// not load: never a broken image.
const BadgeImage = ({ artifactUrl, alt = "", className, placeholderClassName }) => {
  const url = imageUrl(artifactUrl);
  const [failedUrl, setFailedUrl] = useState(null);

  if (!url || failedUrl === url) {
    return (
      <span
        className={placeholderClassName}
        data-testid="badge-placeholder"
        aria-hidden="true"
      >
        <i className="pi pi-gift" />
      </span>
    );
  }

  return (
    <img
      src={url}
      alt={alt}
      className={className}
      onError={() => setFailedUrl(url)}
    />
  );
};

export default BadgeImage;
